import * as types from './mutation-types'

export default {
    setLang({ commit }, lang) {
        commit(types.SET_LANG, lang)
    },
    setStartTime({ commit }, time) {
        commit(types.SET_START_TIME, time)
    },
    setEndTime({ commit }, time) {
        commit(types.SET_END_TIME, time)
    },
    setUserInfo({ commit }, userinfo) {
        commit(types.SET_USER, userinfo)
    }
};



// WEBPACK FOOTER //
// ./src/store/actions.js